export default __webpack_public_path__ + "static/media/CBS_sports_footer_logo.87d0f5f6.svg";